import { ASSET_GENERATION_TYPES, GTM_ASSET_TYPE_VALUES } from "@/constants/constants";

export const OUTPUT_CONTENT_MOCK_DATA = {
  HEADLINE: "HEADLINE",
  VISUAL: "VISUAL:",
  SCRIPT: "SCRIPT",
  SHORT_DESCRIPTION: "Short description",
  LANGUAGES_OPTIONS: [
    { id: "1", label: "English" },
    { id: "2", label: "German" },
    { id: "3", label: "Spanish" },
  ],
  IMAGE_FORMAT_OPTIONS: [
    { id: "0", label: "jpeg" },
    { id: "1", label: "png" },
    { id: "2", label: "psd" },
  ],
};

export enum AssetTypeEnum {
  Text = "Text",
  Visual = "Image",
  VisualAndText = "Image + description",
  VideoScript = "Video Script",
}

export enum ASSET_VARIANTS {
  HEADLINE_OVER_IMAGES_TEXT = "Headline over images",
  SHORT_DESCRIPTION = "Image and short description",
  LONG_FORM = "Long Form",
  SHORT_FORM = "Short Form",
  OPEN = "Open",
  HEADLINES = "Headlines",
  HEADLINE = "Headline",
}

export const REPLACE_ALL_CONTENT = "Replace all";

export enum LANGUAGE {
  ENGLISH = "english",
  GERMAN = "german",
  BRAZILIAN_PORTUGUESE = "brazilian portuguese",
}

export enum ACTION_TYPES {
  DOWNLOAD = "download",
  COPY = "copy",
}

export const COPY_BUTTON_ID = "text-copy";
export const DOWNLOAD_TEXT_BUTTON_ID = "download-text";

export const ASSET_TYPES = {
  DESCRIPTION: "description",
  VIDEO_SCRIPT: "videoScript",
  IMAGES: "images",
  BLOG: "blog",
} as const;

export const validTextAssetTypes = [ASSET_TYPES.DESCRIPTION, ASSET_TYPES.VIDEO_SCRIPT];

export const ASSET_TYPE_MAP = {
  [ASSET_TYPES.IMAGES]: GTM_ASSET_TYPE_VALUES.IMAGE,
  [ASSET_TYPES.VIDEO_SCRIPT]: GTM_ASSET_TYPE_VALUES.VIDEO_SCRIPT,
  [ASSET_TYPES.DESCRIPTION]: GTM_ASSET_TYPE_VALUES.TITLE_DESCRIPTION,
  [ASSET_TYPES.BLOG]: GTM_ASSET_TYPE_VALUES.BLOG
};

export const ACTION_TYPE = {
  DOWNLOAD: "download",
  COPY: "copy",
} as const;

export enum imageUrlEnum {
  PNG = "pngURL",
  JPEG = "jpegURL",
  PSD = "psdURL",
}

export const IMAGE_TYPE = "lifestyle";

export const visualAssetTypes = [
  AssetTypeEnum.Visual,
  AssetTypeEnum.VisualAndText,
  AssetTypeEnum.VideoScript,
  ASSET_GENERATION_TYPES.VISUAL,
  ASSET_GENERATION_TYPES.VISUAL_TEXT,
  ASSET_GENERATION_TYPES.VIDEO_SCRIPT,
];
